import { use, type Context } from 'react';

type OptionalContext<T> = T | undefined | null;

type UseRequiredContextParams<T> = {
  context: Context<OptionalContext<T>>;
  hookName: string;
  providerName: string;
};

type UseRequiredContext = <T>(params: UseRequiredContextParams<T>) => T;

export const useRequiredContext: UseRequiredContext = <T>({
  context,
  hookName,
  providerName,
}: UseRequiredContextParams<T>): T => {
  const value = use(context);
  if (value == null) {
    throw new Error(`${hookName} must be used within ${providerName}`);
  }
  return value;
};
